export default {
  alerts: [],
};
